import { render, staticRenderFns } from "./form-produto-estoque.vue?vue&type=template&id=5175a87a&scoped=true&"
import script from "./form-produto-estoque.vue?vue&type=script&lang=js&"
export * from "./form-produto-estoque.vue?vue&type=script&lang=js&"
import style0 from "./form-produto-estoque.vue?vue&type=style&index=0&id=5175a87a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5175a87a",
  null
  
)

export default component.exports